<div
  class="excelbook"
  style="width: 100%; height: 100%; position: relative"
  (keydown)="hidePopup($event)"
>
  <div class="row ribbon-container">
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="btn-group">
          <div class="btn btn-default btn-large no-border">
            <span class="fal fa-upload"></span>
            <span class="text">Load</span>
            <input
              type="file"
              class="upload"
              (change)="importExcel($event)"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel.sheet.macroEnabled.12"
            />
          </div>
          <button
            class="btn btn-default btn-large no-border"
            (click)="exportExcel()"
          >
            <span class="fal fa-download"></span>
            <span class="text">Save</span>
          </button>
          <button
            class="btn btn-default btn-large no-border"
            (click)="showFieldPanel = !showFieldPanel"
          >
            <span class="fal fa-columns"></span>
            <span class="text">Columns</span>
          </button>
          <!--<button type="button" class="btn btn-default no-border" title="Save formula values."-->
          <!--(click)="toggleIncludeFormulaValues()">-->
          <!--<span class="fa {{includeFormulaValues ? 'fa-check-square-o' : 'fa-square-o' }}"></span>-->
          <!--<span>Formula Values</span>-->
          <!--</button>-->
          <button
            class="btn btn-default btn-large no-border"
            (click)="newFile()"
          >
            <span class="fal fa-file"></span>
            <span class="text">New</span>
          </button>
        </div>
      </div>
      <div class="panel-footer text-center">File</div>
    </div>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="btn-group btn-group-h">
          <button
            type="button"
            class="btn btn-default btn-small"
            title="Undo"
            [disabled]="!(undoStack && undoStack.canUndo)"
            (click)="undo()"
          >
            <span class="fal fa-reply"></span>
            <span class="text">Undo</span>
          </button>
          <button
            type="button"
            class="btn btn-default btn-small"
            title="Redo"
            [disabled]="!(undoStack && undoStack.canRedo)"
            (click)="redo()"
          >
            <span class="fal fa-share"></span>
            <span class="text">Redo</span>
          </button>
        </div>
      </div>
      <div class="panel-footer text-center">Undo / Redo</div>
    </div>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="btn-group-vertical">
          <wj-combo-box
            #cboFontName
            style="width: 120px"
            [itemsSource]="fonts"
            [selectedIndex]="10"
            [displayMemberPath]="'name'"
            [selectedValuePath]="'value'"
            [isEditable]="false"
            (initialized)="cboFontNameInit(cboFontName)"
          >
          </wj-combo-box>
          <wj-combo-box
            #cboFontSize
            style="width: 60px"
            [itemsSource]="fontSizeList"
            [selectedIndex]="5"
            [displayMemberPath]="'name'"
            [selectedValuePath]="'value'"
            [isEditable]="false"
            (initialized)="cboFontSizeInit(cboFontSize)"
          >
          </wj-combo-box>
          <div class="btn-group btn-group-h">
            <button
              type="button"
              class="btn btn-default btn-small {{
                selectionFormatState.isBold ? 'active' : ''
              }}"
              title="Bold"
              (click)="applyBoldStyle()"
            >
              <span class="fal fa-bold"></span>
              <span class="text">Bold</span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-small {{
                selectionFormatState.isItalic ? 'active' : ''
              }}"
              title="Italic"
              (click)="applyItalicStyle()"
            >
              <span class="fal fa-italic"></span>
              <span class="text">Italic</span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-small {{
                selectionFormatState.isUnderline ? 'active' : ''
              }}"
              title="Underline"
              (click)="applyUnderlineStyle()"
            >
              <span class="fal fa-underline"></span>
              <span class="text">Underline</span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-small"
              title="Fill Color"
              (click)="showColorPicker($event, true)"
            >
              <span class="fal fa-font"></span>
              <span class="text">Fill</span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-small"
              title="Font Color"
              (click)="showColorPicker($event, false)"
            >
              <span class="fal fa-font"></span>
              <span class="text">Font</span>
            </button>
          </div>
        </div>
      </div>
      <div class="panel-footer text-center">Font</div>
    </div>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="btn-group-vertical">
          <div class="btn-group btn-group-h">
            <button
              type="button"
              class="btn btn-default btn-small {{
                selectionFormatState.textAlign === 'left' ? 'active' : ''
              }}"
              title="Left"
              (click)="applyCellTextAlign('left')"
            >
              <span class="fal fa-align-left"></span>
              <span class="text">Left</span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-small {{
                selectionFormatState.textAlign === 'center' ? 'active' : ''
              }}"
              title="Center"
              (click)="applyCellTextAlign('center')"
            >
              <span class="fal fa-align-center"></span>
              <span class="text">Center</span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-small {{
                selectionFormatState.textAlign === 'right' ? 'active' : ''
              }}"
              title="Right"
              (click)="applyCellTextAlign('right')"
            >
              <span class="fal fa-align-right"></span>
              <span class="text">Right</span>
            </button>

            <button
              type="button"
              class="btn btn-default btn-small"
              title="{{
                selectionFormatState.isMergedCell ? 'UnMerge' : 'Merge'
              }}"
              [disabled]="selectedTable != null"
              (click)="mergeCells()"
              style="clear: both"
            >
              <span
                class="fal fa-compress"
                style="transform: rotate(90deg)"
              ></span>
              <span class="text">merge</span>
            </button>
          </div>
        </div>
      </div>
      <div class="panel-footer text-center">Alignment</div>
    </div>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-default btn-large no-border"
            (click)="freeze()"
          >
            <span class="fal fa-list"></span>
            <span class="text">{{ isFrozen ? "Unfreeze" : "Freeze" }}</span>
          </button>
        </div>
      </div>
      <div class="panel-footer text-center">View</div>
    </div>
    <div class="panel panel-default">
      <div class="panel-body">
        <button
          type="button"
          class="btn btn-default btn-large no-border"
          (click)="excelStyle.show()"
        >
          <span class="fal fa-pencil"></span>
          <span class="text">Styles</span>
        </button>
      </div>
      <div class="panel-footer text-center">Styles</div>
    </div>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-default btn-large no-border"
            (click)="excelSort.show()"
          >
            <span class="fal fa-sort-amount-desc"></span>
            <span class="text">Sort</span>
          </button>
          <button
            type="button"
            class="btn btn-default btn-large no-border"
            (click)="showFilter()"
          >
            <span class="fal fa-filter"></span>
            <span class="text">Filter</span>
          </button>
        </div>
      </div>
      <div class="panel-footer text-center">Editing</div>
    </div>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-default btn-large no-border"
            (click)="showChartTypes($event)"
          >
            <span class="fal fa-bar-chart"></span>
            <span class="text">Insert Chart</span>
          </button>
        </div>
      </div>
      <div class="panel-footer text-center">Charts</div>
    </div>
    <div class="panel panel-default" *ngIf="selectedTable != null">
      <div class="panel-body">
        <div class="btn-group-vertical form-check">
          <div>
            <label class="form-check-label">
              <input
                class="form-check-input"
                type="checkbox"
                [(ngModel)]="selectedTable.showHeaderRow"
              />
              Header Row
            </label>
          </div>
          <div>
            <label class="form-check-label">
              <input
                class="form-check-input"
                type="checkbox"
                [(ngModel)]="selectedTable.showTotalRow"
              />
              Total Row
            </label>
          </div>
          <div>
            <label class="form-check-label">
              <input
                class="form-check-input"
                type="checkbox"
                [(ngModel)]="selectedTable.showBandedRows"
              />
              Banded Rows
            </label>
          </div>
        </div>
        <div class="btn-group-vertical form-check">
          <div>
            <label class="form-check-label">
              <input
                class="form-check-input"
                type="checkbox"
                [(ngModel)]="selectedTable.alterFirstColumn"
              />
              First Column
            </label>
          </div>
          <div>
            <label class="form-check-label">
              <input
                class="form-check-input"
                type="checkbox"
                [(ngModel)]="selectedTable.alterLastColumn"
              />
              Last Column
            </label>
          </div>
          <div>
            <label class="form-check-label">
              <input
                class="form-check-input"
                type="checkbox"
                [(ngModel)]="selectedTable.showBandedColumns"
              />
              Banded Columns
            </label>
          </div>
        </div>
        <div class="btn-group-vertical form-check" style="display: none">
          <div>
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox" />
              Filter Button
            </label>
          </div>
        </div>
        <div class="btn-group-vertical">
          <wj-combo-box
            #cboTableStyles
            [itemsSource]="tableStyleNames"
            [isEditable]="false"
            (initialized)="cboTableStylesInit(cboTableStyles)"
          >
          </wj-combo-box>
        </div>
      </div>
      <div class="panel-footer text-center">Table Style Options</div>
    </div>
  </div>
  <!-- the boxes -->
  <div class="top-boxes row">
    <div class="col-sm-1 col-xs-2 position">{{ selection.position }}</div>
    <div class="col-sm-1 col-xs-2 fn-label text-right">fx</div>
    <div class="col-sm-10 col-xs-8 fn-box">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="selection.content"
        (keydown)="updateSelectionContent($event)"
        (keyup)="showFunctionList($event)"
        (focus)="pendingCellEditAction()"
      />
    </div>
  </div>
  <!-- the grid -->
  <div class="row" id="flexsheetContainer">
    <!--<wj-flex-sheet #flexSheet (initialized)="flexInitialized(flexSheet)">-->
    <!--<wj-sheet name="sheet1"></wj-sheet>-->
    <!--</wj-flex-sheet>-->
    <div id="flexSheet"></div>
  </div>

  <!-- the status bar -->
  <!--<div class="row status text-right" style="padding-right:10px">Ready</div>-->
</div>
<wj-color-picker
  style="display: none; position: fixed; z-index: 100"
  #colorPicker
  (initialized)="colorPickerInit(colorPicker)"
></wj-color-picker>
<wj-list-box
  style="display: none; position: fixed; z-index: 100"
  #lbChartTypes
  [itemsSource]="chartTypes"
  (initialized)="lbChartTypesInit(lbChartTypes)"
></wj-list-box>
<div
  class="modal fade"
  bsModal
  #excelSort="bs-modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-static-name"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="excelSort.hide()"
          aria-hidden="true"
        >
          &times;
        </button>
        <h4 class="modal-title">Sort</h4>
      </div>
      <div class="modal-body">
        <div class="row well well-lg">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-default"
              (click)="addSortLevel()"
            >
              <span class="glyphicon glyphicon-plus-sign"></span>Add Level
            </button>
            <button
              type="button"
              class="btn btn-default"
              (click)="deleteSortLevel()"
            >
              <span class="glyphicon glyphicon-remove-sign"></span>Delete Level
            </button>
            <button
              type="button"
              class="btn btn-default"
              (click)="copySortLevel()"
            >
              <span class="glyphicon glyphicon-copy"></span>Copy Level
            </button>
          </div>
          <div class="btn-group">
            <button
              id="moveup"
              type="button"
              class="btn btn-default"
              [disabled]="
                sortManager && sortManager.sortDescriptions.currentPosition <= 0
              "
              (click)="moveSortLevel(-1)"
            >
              <span class="fal fa-arrow-up"></span>
            </button>
            <button
              id="movedown"
              type="button"
              class="btn btn-default"
              [disabled]="
                sortManager &&
                sortManager.sortDescriptions.currentPosition >=
                  sortManager.sortDescriptions.itemCount - 1
              "
              (click)="moveSortLevel(1)"
            >
              <span class="fal fa-arrow-down"></span>
            </button>
          </div>
        </div>
        <br />
        <div class="row" id="sortTable">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="text-center">Column</th>
                <th class="text-center">Order</th>
              </tr>
            </thead>
            <tbody *ngIf="sortManager">
              <tr
                *ngFor="let sortItem of sortManager.sortDescriptions.items"
                (click)="sortManager.sortDescriptions.moveCurrentTo(sortItem)"
                [ngClass]="{
                  success: sortItem === sortManager.sortDescriptions.currentItem
                }"
              >
                <td>
                  <select
                    class="form-control"
                    (change)="applySortColumnIndex($event, sortItem)"
                  >
                    <option value="-1"></option>
                    <option
                      *ngFor="let column of columns; let i = index"
                      [selected]="i === sortItem.columnIndex"
                      value="{{ i }}"
                    >
                      {{ column.binding | translate }}
                    </option>
                  </select>
                </td>
                <td>
                  <select
                    class="form-control"
                    (change)="applySortAscending($event, sortItem)"
                  >
                    <option [value]="true" [selected]="sortItem.ascending">
                      Ascending
                    </option>
                    <option [value]="false" [selected]="!sortItem.ascending">
                      Descending
                    </option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          data-dismiss="modal"
          (click)="commitSort(); excelSort.hide()"
        >
          OK
        </button>
        <button
          type="button"
          class="btn btn-default"
          data-dismiss="modal"
          (click)="cancelSort(); excelSort.hide()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  bsModal
  #excelStyle="bs-modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-static-name"
>
  >
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="excelStyle.hide()"
          aria-hidden="true"
        >
          &times;
        </button>
        <h4 class="modal-title">Styles</h4>
      </div>
      <div class="modal-body">
        <div class="well well-sm">
          <h4 class="text-primary">Good, bad and neutral</h4>
          <div class="btn-group btn-group-justified">
            <div class="btn-group">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-default"
                (mouseover)="applyCellStyle('normal')"
                (click)="applyCellStyle()"
                (mouseleave)="applyCellStyle('', true)"
              >
                <span>Normal</span>
              </button>
            </div>
            <div class="btn-group">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-default bad-style"
                (mouseover)="applyCellStyle('bad')"
                (click)="applyCellStyle()"
                (mouseleave)="applyCellStyle('', true)"
              >
                <span>Bad</span>
              </button>
            </div>
            <div class="btn-group">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-default good-style"
                (mouseover)="applyCellStyle('good')"
                (click)="applyCellStyle()"
                (mouseleave)="applyCellStyle('', true)"
              >
                <span>Good</span>
              </button>
            </div>
            <div class="btn-group">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-default neutral-style"
                (mouseover)="applyCellStyle('neutral')"
                (click)="applyCellStyle()"
                (mouseleave)="applyCellStyle('', true)"
              >
                <span>Neutral</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-sidebar
  [(visible)]="showFieldPanel"
  position="right"
  styleClass="kl-sidebar"
  (onHide)="showFieldPanel = false"
>
  <div class="sidebar-header">
    <label>{{ "column_add_or_remove" | translate }}</label>
  </div>
  <kl-column-picker
    *ngIf="showFieldPanel"
    [flexGrid]="flexSheet"
  ></kl-column-picker>
</p-sidebar>
